import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { holidayCalendarRouting } from './holiday-calendar.routing';
import { HolidayCalendarComponent } from './holiday-calendar.component';
import { HolidayCalendarRest } from './holiday-calendar.rest';
import { LoginRest } from '../../login/login.rest';
import { SharedModule } from '../../core/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    holidayCalendarRouting,
    SharedModule
  ],
  declarations: [HolidayCalendarComponent],
  exports: [],
  providers: [HolidayCalendarRest, LoginRest]
})
export class HolidayCalendarModule { }
